module.exports = __webpack_public_path__ + "img/CEMA.0982ff21.png";